/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:08:45
 * @Explain: 公共类
 */

export default {
  'APP.DEMO.TEXT': '数量',
  'APP.NAME': 'SmartLink',
  'APP.ANNOUNCEMENT': '当前以内部管理员身份登录，禁止任何数据写入操作。',
  // 公用类
  'COMMON.TIME.NUMBER': '数量',
  'COMMON.TIME.ZONE': '时区',
  'COMMON.LOGIN.OUT': '登出',
  'COMMON.YES': '是',
  'COMMON.NO': '否',
  'COMMON.TIPS': '提示',
  'COMMON.CANCEL': '取消',
  'COMMON.DETERMINE': '确定',
  'COMMON.CONFIRM': '确认',
  'COMMON.CLOSE': '关闭',
  'COMMON.I.GOT.IT': '我知道了',
  'COMMON.DELETE': '删除',
  'COMMON.REMOVE': '删除',
  'COMMON.NEWLY.ADDED': '新增',
  'COMMON.CREATE': '创建',
  'COMMON.EDIT': '编辑',
  'COMMON.SETTING': '设置',
  'COMMON.SETTINGS': '设置',
  'COMMON.SET.UP': '设置',
  'COMMON.REVOKE': '撤销',
  'COMMON.CLEAR.AWAY': '清除',
  'COMMON.SAVE': '保存',
  'COMMON.DON.T.SAVE': '不保存',
  'COMMON.SAVE.CHECK': '保存并检查',
  'COMMON.SAVE.EXIT': '保存并退出',
  'COMMON.SAVE.USE': '保存并使用',
  'COMMON.CONTINUE': '继续',
  'COMMON.SAVE.CONFIGURE': '保存并进入玩家页面',
  'COMMON.COPY': '复制',
  'COMMON.DUPLICATE': '复制',
  'COMMON.COPIED': '已复制',
  'COMMON.COPIED.TO.CLIPBOARD': '复制到剪切板',
  'COMMON.COPY.SUCCEEDED': '复制成功',
  'COMMON.COPY.FAILED': '复制失败',
  'COMMON.DETAILS': '详情',
  'COMMON.VIEW.DETAILS': '查看详情',
  'COMMON.EXPORT.DETAILS': '导出详情',
  'COMMON.PREVIEW': '预览',
  'COMMON.DOWNLOAD': '下载',
  'COMMON.TEMPLATE': '模板',
  'COMMON.DOWNLOAD.TEMPLATE': '下载模板',
  'COMMON.SIGN.OUT': '退出',
  'COMMON.START': '开始',
  'COMMON.RESTART': '重启',
  'COMMON.TERMINATION': '终止',
  'COMMON.TERMINATION.STATE': '已终止',
  'COMMON.SUSPEND': '暂停',
  'COMMON.OPERATION': '操作',
  'COMMON.PREV': '上一步',
  'COMMON.PREV.GO.BACK': '上一步',
  'COMMON.NEXT': '下一步',
  'COMMON.SUBMIT': '提交',
  'COMMON.EXPLAIN': '说明',
  'COMMON.ANY': '任何',
  'COMMON.ALL': '所有',
  'COMMON.ALLS': '全部',
  'COMMON.SELECT.ALL': '全选',
  'COMMON.SEARCH': '搜索',
  'COMMON.FORMAT': '格式化',
  'COMMON.RENAME': '重命名',
  'COMMON.SUBMIT.SUCCEEDED': '提交成功',
  'COMMON.SAVE.SUCCEEDED': '保存成功',
  'COMMON.SEND.SUCCEEDED': '已成功发送',
  'COMMON.EDIT.SUCCEEDED': '编辑成功',
  'COMMON.PUBLISH.SUCCESS': '发布成功',
  'COMMON.SUCCESSFUL.APPLICATION': '申请成功',
  'COMMON.DELETE.SUCCEEDED': '删除成功',
  'COMMON.DELETE.FAILED': '删除失败',
  'COMMON.REVOKE.SUCCEEDED': '撤销成功',
  'COMMON.REVOKE.FAILED': '撤销失败',
  'COMMON.STATUS.SUCCEEDED': '开始成功',
  'COMMON.PAUSE.SUCCEEDED': '暂停成功',
  'COMMON.TERMINATION.SUCCEEDED': '终止成功',
  'COMMON.URGED.SUCCESSFULLY': '催办成功',
  'COMMON.UPLOAD.SUCCEEDED': '上传成功',
  'COMMON.CANCEL.UPLOAD': '取消上传',
  'COMMON.CANCEL.UPLOAD.2': '取消上传',
  'COMMON.RE.UPLOAD': '重新上传',
  'COMMON.SELECT.FILE': '选择文件',
  'COMMON.PLEASE.SELECT.UPLOAD.FILE': '请选择上传文件',
  'COMMON.UPLOAD.ERROR.TRY.AGAIN': '上传失败，请重试',
  'COMMON.UPLOAD.ERROR.ALREADY.DELETE': '图片已被删除',
  'COMMON.UPLOAD.ERROR.NETWORK.ERROR': '网络请求异常，请重试',
  'COMMON.UPLOAD.ERROR.GARBLED.CODE': '上传失败，请检查文件是否出现乱码',
  'COMMON.UPLOAD.FILE.BIG.WAIT': '上传文件较大，请耐心等待...',
  'COMMON.UPLOAD.ERROR.EXCEED': 'Excel大小不能超过{maxSize}',
  'COMMON.UPLOAD.ERROR.html.exceed': 'HTML大小不能超过100KB',
  'COMMON.UPLOAD.ERROR.CELL.MAX.LENGTH':
    'Excel单元格内容长度不能超过{maxLength}字符',
  'COMMON.UPLOAD.ERROR.AUDIT.FILE': '上传失败，请检查文件内容',
  'COMMON.FILE.UPLOADING': '文件上传中',
  'COMMON.CLICK.UPLOAD': '点击上传',
  'COMMON.DOWNLOAD.FAIL': '下载失败',
  'COMMON.DRAG.AREA': '拖拽到此区域',
  'COMMON.RELEASE.MOUSE': '释放鼠标',
  'COMMON.MORE': '更多',
  'COMMON.TIME': '时间',
  'COMMON.SEARCHSEC': '检索',
  'COMMON.RESET': '重置',
  'COMMON.REFRESH': '刷新',
  'COMMON.REFRESH.PAGE': '刷新页面',
  'COMMON.UNCATE': '未分类（默认）',
  'COMMON.TEMPLATE.EXCEED': '文件大小超过限制',
  'COMMON.EXPORT': '导出',
  'COMMON.ORDER.NUMBER': '序号',
  'COMMON.LANGUAGE': '语言',
  'COMMON.EMAIL.CREATE.TYPE': '创建格式（新增）',
  'COMMON.LOCATION': '地区',
  'COMMON.SWITCH.LANGUAGE': '切换成英文',
  'COMMON.CH': '中文',
  'COMMON.EN': '英文',
  'COMMON.OTHER': '其他',
  'COMMON.OTHERS': '其他',
  'COMMON.COUNTRY': '区域',
  'COMMON.ALL.COUNTRIES': '所有区域',
  'COMMON.SUBSCRIBE': '订阅',
  'COMMON.UNSUBSCRIBE': '取消订阅',
  'COMMON.LOADING': '加载中',
  'COMMON.LOADING.LOWERCASE': '加载中',
  'COMMON.NO.DATA': '暂无数据',
  'COMMON.NO.MORE.DATA': '暂无更多数据',
  'COMMON.NO.LOADING.FAILED': '加载失败',
  'COMMON.RETRY': '重试',
  'COMMON.VIEW.ALL': '查看全部',
  'COMMON.SEE.MORE': '查看更多',
  'COMMON.SEE': '查看',
  'COMMON.TOTAL': '合计',
  'COMMON.ADOPT': '通过',
  'COMMON.REJECT': '驳回',
  'COMMON.STATUS.ADOPT': '通过',
  'COMMON.STATUS.REJECT': '驳回',
  'COMMON.URGE': '催办',
  'COMMON.URGED': '已催办',
  'COMMON.SOURCE': '来源',
  'COMMON.APPLY': '申请',
  'COMMON.BACK': '返回',
  'COMMON.TAG': '标签',
  'COMMON.FIELD.NAME': '字段名',
  'COMMON.DATA.TYPE': '数据类型',
  'COMMON.VALUE': '值',
  'COMMON.CREATED.BY': '创建人',
  'COMMON.LAST.UPDATE.BY': '最后更新人',
  'COMMON.LAST.MODIFIED.TIME': '最后修改时间',
  'COMMON.LAST.UPDATE.TIME': '最后更新时间',
  'COMMON.REMARKS': '备注',
  'COMMON.DEFAULT': '默认',
  'COMMON.EMAIL': '邮箱',
  'COMMON.FIXED': '固定',
  'COMMON.DYNAMIC': '动态',
  'COMMON.RECORD.COUNT': '共 {recordCount} 条',
  'COMMON.SEND.CODE': '发送验证码',
  'COMMON.SENT.SUCCESS': '发送成功',
  'COMMON.ENTER.NOW': '现在进入',
  'COMMON.ENTER': '进入',
  'COMMON.CREATE.NOW': '现在创建',
  'COMMON.PREFERENCE': '偏好',
  'COMMON.NONE': 'None',
  'COMMON.EXPAND': '展开',
  'COMMON.COLLAPSE': '收起',
  'COMMON.URL': '链接',
  'COMMON.STATUS': '状态',
  'COMMON.DONE': '完成',
  'COMMON.ENABLE': '启用',
  'COMMON.DISABLE': '禁用',
  'COMMON.ENABLED': '已启用',
  'COMMON.NOT.ENABLED': '未启用',
  'COMMON.DISABLED': '已禁用',
  'COMMON.EMAIL.DELETED': '*邮箱已删除*',
  'COMMON.DATA.ERROR.PLEASE.CHECK': '数据异常，请检查',
  'COMMON.RATE': '比率',
  'COMMON.SERVER': '服务器',

  // 快捷时间选择
  'COMMON.TO': '至',
  'COMMON.NOW': '现在',
  'COMMON.FIVE.MINUTES.LATER': '5分钟后',
  'COMMON.ONE.DAY.LATER': '1天后',
  'COMMON.MORNING': '上午',
  'COMMON.AFTERNOON': '下午',
  'COMMON.NIGHT': '晚上',
  'COMMON.HOURS': '小时',
  'COMMON.DAYS': '天',
  'COMMON.DAYS.UNIT': '天数',
  'COMMON.WEEKS': '周',

  // 提示语集 - 询问
  'COMMON.IS.SUBSCRIBE': '是否订阅？',
  'COMMON.IS.UNSUBSRIBE': '是否取消订阅？',
  'COMMON.IS.DELETE': '是否确认删除？',
  'COMMON.SELECT.ONE': '至少选择一项',
  'COMMON.QUERY.NUMBER.RESULT': '查询到{num}条结果',

  // 提示语 - 请输入、请选择、选择
  /** 请选择 */
  'COMMON.PLEASE.SELECT': '请选择',
  'COMMON.PLEASE.SELECT.DATE': '请选择日期',
  'COMMON.PLEASE.SELECT.TIME': '请选择时间',
  'COMMON.PLEASE.SELECT.SOURCE': '请选择来源',
  'COMMON.PLEASE.SELECT.LABEL': '请选择标签',
  'COMMON.PLEASE.SELECT.SEGMENT': '请选择分层',
  'COMMON.PLEASE.SELECT.LANGUAGE': '请选择语言',
  'COMMON.PLEASE.SELECT.LOCATION': '请选择区域',
  'COMMON.PLEASE.SELECT.PREFERENCE': '请选择偏好',
  'COMMON.PLEASE.SELECT.SENDER.NAME': '请选择发件人',
  'COMMON.PLEASE.SELECT.SENDER.ADDRESS': '请选择发件地址',
  'COMMON.PLEASE.SELECT.SENDER.DOMAIN': '请选择发件域名',
  /** 选择 */
  'COMMON.SELECT': '选择',
  'COMMON.SELECT.DATE': '选择日期',
  'COMMON.SELECT.TIME': '选择时间',
  'COMMON.SELECT.SOURCE': '选择来源',
  'COMMON.SELECT.LABEL': '选择标签',
  'COMMON.SELECT.SEGMENT': '选择分层',
  'COMMON.SELECT.LANGUAGE': '选择语言',
  'COMMON.SELECT.LOCATION': '选择区域',
  'COMMON.SELECT.PREFERENCE': '选择偏好',
  'COMMON.SELECT.SENDER.NAME': '选择发件人',
  'COMMON.SELECT.SENDER.ADDRESS': '选择发件地址',
  'COMMON.SELECT.SENDER.DOMAIN': '选择发件域名',
  'COMMON.SELECT.VALUES': '请选择',
  /** 请输入  */
  'COMMON.PLEASE.ENTER': '请输入',
  'COMMON.ENTER.HERE': '请输入',
  'COMMON.TYPE.HERE': '请输入',
  'COMMON.INPUT.ERROR': '输入有误，请重新输入',
  'COMMON.PLEASE.ENTER.EMAIL.REG': '请输入正确的邮箱地址',
  'COMMON.PLEASE.ENTER.EMAIL.EXIST': '输入的邮箱地址已存在',
  'COMMON.PLEASE.ENTER.REMARKS': '请输入备注',
  'COMMON.PLEASE.SELECT.SUBJECT': '请输入主题',
  'COMMON.PLEASE.ENTER.XX.DIGIT.CODE': '请输入{num}位数字码',
  'COMMON.PLEASE.ENTER.VALUES': '请输入',
  /** 输入 */
  'COMMON.ENTER.REMARKS': '输入备注',
  'COMMON.SELECT.SUBJECT': '输入主题',

  // 提示语集 - 无权限
  'COMMON.NO.PERMISSION.HEADERS.TITLE': '无权限',
  'COMMON.NO.PERMISSION.TO.ACCESS':
    '您暂无此功能访问权限，请联系{HIGHEST_AUTHS}角色协助处理',
  'COMMON.NO.PERMISSION.DEMO': 'Demo项目暂不提供此功能的体验',
  'COMMON.NO.PERMISSION.DEMO.EXPLAIN.BTN1': '立即加入项目',
  'COMMON.NO.PERMISSION.DEMO.EXPLAIN': ' 或 ',
  'COMMON.NO.PERMISSION.DEMO.EXPLAIN.BTN2': '创建新项目',

  // 左侧菜单
  'LEFT.MENU.PROJECT': '项目',
  'LEFT.MENU.FUNCTION': '功能',
  'LEFT.MENU.HOME': '主页',
  'LEFT.MENU.CONTACTS': '联系人',
  'LEFT.MENU.EMAIL': '邮件活动',
  'LEFT.MENU.DASHBOARD': '数据看板',
  'LEFT.MENU.OVERVIEW': '概览',
  'LEFT.MENU.ORGANIZE': '管理',
  'LEFT.MENU.ECONOMY': '游戏资产',
  'LEFT.MENU.ANALYTICS': '活动分析',
  'LEFT.MENU.EVENT': '邮件活动',
  'LEFT.MENU.EVENT1': '常规活动',
  'LEFT.MENU.EVENT2': '周期活动',
  'LEFT.MENU.EVENT3': '审批活动',
  'LEFT.MENU.EVENT4': 'A/B测试',
  'LEFT.MENU.EVENT5': '自动化活动',
  'LEFT.MENU.PLAYER.JOURNEY': 'Player journey',
  'LEFT.MENU.EVENT6': '玩家旅程',
  'LEFT.MENU.EVENT.WHATSAPP': 'WhatsApp活动',
  'LEFT.MENU.WHATSAPP': 'WhatsApp活动',
  'LEFT.MENU.PUSH': '消息推送',
  'LEFT.MENU.PUSH.MANAGEMENT': '推送管理',
  'LEFT.MENU.PUSH.EXPERIMENT': '推送实验',
  'LEFT.MENU.PUSH.DEFAULT': '默认推送',
  'LEFT.MENU.PUSH.APPROVAL': '待审批',
  'LEFT.MENU.USER': '联系人',
  'LEFT.MENU.USER0': '分层规则',
  'LEFT.MENU.USER1': '所有联系人',
  'LEFT.MENU.USER2': '标签管理',
  'LEFT.MENU.USER3': '偏好管理',
  'LEFT.MENU.USER4': '表单',
  'LEFT.MENU.TEMPLATE': '邮件模板',
  'LEFT.MENU.TEMPLATE.MARKET': '营销模板',
  'LEFT.MENU.TEMPLATE.TRANSACTION': '事务性模板',
  'LEFT.MENU.TEMPLATE1': '邮件模板',
  'LEFT.MENU.TEMPLATE2': '短信模板',
  'LEFT.MENU.TEMPLATE3': '资源码管理',
  'LEFT.MENU.WHATSAPP.TEMPLATE': 'WhatsApp模板',
  'LEFT.MENU.DATA': '报表',
  'LEFT.MENU.ACTIVITY.REPORT': '活动报表',
  // 'LEFT.MENU.CONTACT.REPORT': '联系人报表',
  'LEFT.MENU.AUTOMATIONS': 'Automations',
  'LEFT.MENU.PLAYTEST.HUB': '游戏测试中心',
  'LEFT.MENU.TEST.MANAGEMENT': '测试管理',
  'LEFT.MENU.TESTER.LIST': '测试列表',

  'LEFT.MENU.Hi': '您好 {accountName}',
  'LEFT.MENU.MY.PROJECT': '我的项目',
  'LEFT.MENU.SETTING': '项目设置',
  'LEFT.MENU.EXPORT.CENTER': '导出中心',
  'LEFT.MENU.MY.PROFILES': '账号中心',
  'LEFT.MENU.PERMISSION.LIST': '待我审批',
  'LEFT.MENU.DEVELOPERS': 'API接口文档',
  'LEFT.MENU.USE.GUIDE': '文档 & API',
  'LEFT.MENU.VERSIONS': '版本',
  'LEFT.MENU.VERSIONS.TITLE': '新功能',

  // 符号colon
  'COMMON.SYMBOL.COLON': '：',
  'COMMON.SYMBOL.COMMA': '，',
  'COMMON.SYMBOL.COMMA.EMPTY': '，',
  'COMMON.SYMBOL.SEMICOLON': '；',

  // 联系人模板
  LOCATION_CODE: '区域编码',
  LANGUAGE_CODE: '语言编码',
  EMAIL_ADDRESS: '邮箱地址',

  'COMMON.CAMPAIGN': '活动',
  'COMMON.FORM': '表单',

  // 抽屉
  'COMMON.DRAWER.CHECKBOX.DESC': '不再自动展开',

  'COMMON.SENDER.NAME.IS.DELETED': '发件人名称被删除',

  // 时间
  'COMMON.UPDATE.TIME': '更新时间',
  // 创建导出请求提示
  'CREATED.EXPORT.REQ.INFOR.READY':
    '您的导出已开始。完成后我们会发送电子邮件至{email}',

  // 默认 对比更新主题预览文本弹窗标题
  'COMMON.COMPARE.UPDATE.SUBJECT.PREVIEW.TEXT.DIALOG.TITLE': '更新提醒',
  // 默认 对比更新主题预览文本弹窗 子级文案
  'COMMON.COMPARE.UPDATE.SUBJECT.PREVIEW.TEXT.DIALOG.Text':
    '检测到主题和预览文本已更新',

  // 默认 对比更新主题预览文本 确认按钮文案
  'COMMON.COMPARE.UPDATE.SUBJECT.PREVIEW.TEXT.DIALOG.CONFIRM.BTN.TEXT':
    '确认更新',

  // 对比弹窗 旧的主题与预览文本 标题
  'COMMON.COMPARE.UPDATE.SUBJECT.PREVIEW.TEXT.DIALOG.CONFIRM.OLD.SUBJECT.PREVIEW.TEXT.TITLE':
    '原模板主题和预览文本',
  // 对比弹窗 新的的主题与预览文本 标题
  'COMMON.COMPARE.UPDATE.SUBJECT.PREVIEW.TEXT.DIALOG.CONFIRM.NEW.SUBJECT.PREVIEW.TEXT.TITLE':
    '更新为',
  // 对比弹窗 主题
  'COMMON.COMPARE.UPDATE.SUBJECT.PREVIEW.TEXT.DIALOG.CONFIRM.SUBJECT': '主题:',
  // 对比弹窗 预览文本
  'COMMON.COMPARE.UPDATE.SUBJECT.PREVIEW.TEXT.DIALOG.CONFIRM.PREVIEW':
    '预览文本: {PREVIEW}',
};
